module.exports = __webpack_public_path__ + "static/8-80cdf39b96bfe836619b0adb83c9a006.jpg";